import {Locale} from '@aboutyou/config';

export const getWoohooCampaignLogoSuffix = (locale: string) => {
  switch (locale) {
    case Locale.lt_LT:
      return 'Valio';
    case Locale.lv_LV:
      return 'URRĀ';
    case Locale.it_IT:
      return 'WOOOW';
    case Locale.pl_PL:
      return 'HURRA';
    case Locale.sl_SI:
    default:
      return 'Woohoo';
  }
};
